
import { FiMapPin } from 'react-icons/fi';
import styled from 'styled-components';
import devices from '@/utilities/devices';

const JobCardContainer = styled.a`
	background-color: ${({ theme }) => theme.color.white};
	border-radius: 4px;
	box-shadow: 0px 0px 10px rgba(63, 6, 43, 0.1);
	display: block;
	margin: .5rem .7rem;
	max-width: 12.5rem;
	min-width: 12.5rem;
	text-decoration: none;
	transition: .3s;

	.job-container {
		padding: 1.25rem;
		.label {
			color: ${({theme}) => theme.color.greyDarker};
			font-size: ${({theme}) => theme.fontSize.XXSMALL};
		}
		.job-name {
			color: ${({theme}) => theme.color.prune};
			font-size: ${({theme}) => theme.fontSize.SMALL};
			text-decoration: underline;
			text-decoration-color: ${({theme}) => theme.color.prune};
		}
	}
	.place-container {
		align-items: center;
		background-color: ${({theme}) => theme.color.beigeLight};
		border-radius: 0 0 4px 4px;
		color: ${({theme}) => theme.color.prune};
		display: flex;
		font-size: ${({theme}) => theme.fontSize.XSMALL};
		padding: 1rem 1.25rem;
		svg {
			font-size: ${({theme}) => theme.fontSize.DEFAULT};
			color: ${({theme}) => theme.color.red};
			padding-right: 5px;
			padding-bottom: 3px;
		}
	}

	:hover {
		box-shadow: 0px 0px 13px rgba(63, 6, 43, 0.13);
		transform: translateY(-3px);
	}

	@media screen and (${devices.mobile}) {
		width: 100%;
		min-width: 100%;
		margin: .7rem 0rem;
		:first-child {
			margin-top: 0;
		}
		:last-child {
			margin-bottom: 0;
		}
	}
`;

const JobCardWithPlace = ({ href, job, place }: { href: string; job: string; place: string }) => {

	return (
		<JobCardContainer href={href}>
			<div className='job-container'>
				<div className='label'> Métier </div>
				<div className='job-name'> {job} </div>
			</div>
			<div className='place-container'>
				<FiMapPin /> {place}
			</div>
		</JobCardContainer>
	);
};

export default JobCardWithPlace;
